"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _internal = _interopRequireDefault(require("./_internal"));
var _react = _interopRequireDefault(require("react"));
var _data = _interopRequireDefault(require("./data"));
var handleChange = function handleChange(value) {
  console.log("selected ".concat(value));
};
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_internal.default, {
    mode: "multiple",
    allowClear: true,
    style: {
      width: '100%'
    },
    options: _data.default,
    listHeight: 200,
    placeholder: "Please select",
    defaultValue: ['a10', 'c12', 'e14'],
    onChange: handleChange
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary', 'colorFillSecondary'],
  key: 'selectTag'
};
var _default = exports.default = componentDemo;